module.exports = __webpack_public_path__ + "static/media/oxy-grill.6e7eb393.jpeg";